import { useRef, useState } from "react";
import { toast } from "react-toastify";

import Modal from "../modal/Modal.js";
import ToastItem from "../ToastItem.js";
import { useTicketContext } from "../../context/TicketContext.js";
import { useNavigate } from "react-router-dom";

const RejectWithCorrespondingModal = ({ slug, onClose }) => {
  const { rejectWithCorrespondingHandler, loading } = useTicketContext();
  const fileInputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [comment, setComment] = useState(""); // State to store the comment
  const [isCheckProcessed, setIsCheckProcessed] = useState(false);
  const [error, setError] = useState(""); // State to store error for each field
  const navigate = useNavigate();

  const handleRemoveError = () => {
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (fileInputRef.current.files.length <= 0) {
      setError("Please attach a file");
      return;
    }

    try {
      const file = fileInputRef.current.files[0];
      await rejectWithCorrespondingHandler(file, {"comment": comment} ); // Passing the comment
      setIsCheckProcessed(true);
      navigate("/manage-ticket?page=1");

    } catch (error) {
      toast.error(error?.message ? error.message : error + "");
      console.error(error?.message ? error.message : error + "");
    }
  };

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const fileUploaded = event.target.files[0];
    setSelectedFile(fileUploaded);
  };

  return (
    <Modal
      title={"Reject with Correspondence"}
      onClose={() => {
        setIsCheckProcessed(false);
        onClose();
      }}
    >
      {isCheckProcessed ? (
        <div className="flex flex-col items-center justify-center h-380 space-y-5">
          <img
            src="/success-fill.svg"
            className=" w-104 cursor-pointer"
            alt="success-icon"
          />
          <p className="font-21-31-400-2 w-566 text-center">
            You have opted to Reject the Check with Correspondence. The process
            has been successfully completed.
          </p>
        </div>
      ) : (
        <form
          onSubmit={handleSubmit}
          className="px-4 my-4 py-2 flex relative flex-col space-y-5"
        >
          {loading && (
            <div className="inset-0 absolute w-full h-full bg-white flex items-center justify-center">
              <p className="font-16-21-400">
                Processing your request. Please wait ...
              </p>
            </div>
          )}

          {error && (
            <ToastItem
              item={error}
              index={1}
              onRemove={handleRemoveError}
              type="error"
            />
          )}

          <div className="flex  px-2 flex-col my-2">
            <label className="mb-2 font-20-30-400" htmlFor={"attachment"}>
              Attachment
            </label>

            <div
              className="flex items-center"
              onClick={handleButtonClick}
              type="button"
            >
              <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                style={{ display: "none" }}
              />
              <img
                src="/attach-file.svg"
                className="w-24 h-24"
                alt="attach-svg"
              />
              {selectedFile ? (
                <p className="ml-4 font-20-30-400 text-success">
                  File attached: "{selectedFile?.name}"
                </p>
              ) : (
                <p className="ml-4 font-20-30-400 text-grey-2">
                  Click here to upload
                </p>
              )}
            </div>
          </div>

          {/** Comment Box */}
          <div className="flex px-2 flex-col my-2">
            <label className="mb-2 font-20-30-400" htmlFor={"comment"}>
              Comment (Optional)
            </label>
            <textarea
              id="comment"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              className="border-2 p-2"
              placeholder="Add your comments here (optional)"
            />
          </div>

          {/** Submit and Cancel Buttons */}
          <div className="flex space-x-4">
            <div className="py-2 w-135">
              <button
                type="submit"
                className="border-none w-full h-49 font-16-21-700 capitalize justify-center rounded-md bg-[#3C394D] px-8 text-sm  text-white shadow-sm sm:w-auto"
              >
                Submit
              </button>
            </div>

            <div className="py-2 w-135">
              <button
                type="button"
                onClick={() => onClose(false)}
                className="border-none w-full h-49 font-16-21-700 capitalize justify-center rounded-md bg-cancel-2 px-8 text-sm   text-white  sm:w-auto"
              >
                Cancel
              </button>
            </div>
          </div>
        </form>
      )}
    </Modal>
  );
};

export default RejectWithCorrespondingModal;
